import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GetGrantsFilter, Grant } from '../models/grant';


@Injectable({
  providedIn: 'root',
})
export class GrantService {
  private baseUrl = `${environment.apiUrl}/grants`;

  constructor(private http: HttpClient) {}

  getGrants(filter: GetGrantsFilter): Observable<Grant[]> {
    let url = `${this.baseUrl}`;
    const params = filter.toQueryParams();

    return this.http.get<Grant[]>(url, { params });
  }

  getGrant(id: string): Observable<Grant> {
    return this.http.get<Grant>(`${this.baseUrl}/${id}`);
  }

  createGrant(grant: Grant): Observable<void> {
    return this.http.post<void>(this.baseUrl, grant);
  }

  updateGrant(id: string, grant: Grant): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, grant);
  }

  deleteGrant(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}